import { useEffect, useState } from 'react';

import { Sentry } from '@willow/shared-web';
import { PortalLoginConfig } from '@willow/types-iso';

import { fetchLoginConfig } from './portalAuthApi';

export type LoginConfigState = { status: 'loading' } | { status: 'ready'; config: PortalLoginConfig };

export const useLoginConfig = (): LoginConfigState => {
  const [state, setState] = useState<LoginConfigState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    fetchLoginConfig()
      .then((config) => {
        if (!cancelled) setState({ status: 'ready', config });
      })
      .catch((error: unknown) => {
        Sentry.captureException(error);
        // Auth0 is what every Portal is on today and it keeps working through the dual window,
        // so it is the safe answer when the lookup fails.
        if (!cancelled) setState({ status: 'ready', config: { willowAuthEnabled: false } });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};
